// Module
var code = "<div id=\"V-905C5CC6-09E8-4481-80A6-E28FAE880467\"> <div data-b-component=\"multilineinput\" class=\"input\" data-b-comp-text=\"{Binding code}\"></div> </div> ";
// Exports
export default code;